import { render } from "./OperationHelpDialog.vue?vue&type=template&id=45b62fd4"
import script from "./OperationHelpDialog.vue?vue&type=script&lang=js"
export * from "./OperationHelpDialog.vue?vue&type=script&lang=js"

import "./OperationHelpDialog.vue?vue&type=style&index=0&id=45b62fd4&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__